import { createContext } from "preact";
import { useContext } from "preact/hooks";

export const MessageAreaWidthContext = createContext(0);

export const MESSAGE_AREA_PADDING = 82;

export function useMessageAreaWidth() {
    return useContext(MessageAreaWidthContext);
}
